import { RefObject, useEffect, useState } from "react";

import { useOnResize } from "@src/hooks/util";
import { useSelector } from "@src/store";
import { selectedVariations } from "@src/store/slices/variations";

export const useSetGridWidthAnalytics = (
  ref: RefObject<HTMLDivElement | null>
) => {
  const variations = useSelector(selectedVariations).length;
  const [gridWidth, setGridWidth] = useState(4);
  const [initializedOnResize, setInitializedOnResize] = useState(false);

  const onResize = useOnResize((ref) => {
    if (variations <= 3) {
      if (ref.clientWidth <= 711) {
        setGridWidth(6);
      } else if (ref.clientWidth < 1200) {
        setGridWidth(4);
      } else {
        setGridWidth(3);
      }
    } else if (variations <= 6) {
      if (ref.clientWidth <= 711) {
        setGridWidth(12);
      } else if (ref.clientWidth < 1200) {
        setGridWidth(6);
      } else {
        setGridWidth(4);
      }
    } else {
      setGridWidth(4);
    }
  });

  useEffect(() => {
    if (ref.current && !initializedOnResize) {
      setInitializedOnResize(true);
      onResize(ref.current);
    }
  }, [
    setInitializedOnResize,
    onResize,
    initializedOnResize,
    ref,
    setGridWidth,
  ]);

  return gridWidth;
};
